/** رقم واتساب ليبيا كامل (بدون +) — يُستخدم إذا كان الرقم من الإعدادات ناقصاً (مثل 218 فقط) */
export const DEFAULT_WHATSAPP_DIGITS = '218917597979';

/**
 * يعيد أرقام واتساب صالحة لـ wa.me: لا يقبل سوى رقم كامل (10 أرقام على الأقل).
 * يمنع روابط من نوع wa.me/218 التي تعرض "Chat on WhatsApp with 218".
 */
export function normalizeWhatsAppDigits(raw) {
  if (raw == null || raw === '') return DEFAULT_WHATSAPP_DIGITS;
  const digits = String(raw).replace(/\D/g, '');
  return digits.length >= 10 ? digits : DEFAULT_WHATSAPP_DIGITS;
}
